<template>
  <form id="frm_action">
    <div class="p-formgrid">
      <div class="">
        <div class="" v-if="$store.getters.type == $constants.TYPE_USER.SUPPER_ADMIN">
          <label class="txt-right required">Công ty</label>
          <DropdownScrollable cusClass="text-box m-0" :loading="loading" width="100%" :show="$store.getters.type == $constants.TYPE_USER.SUPPER_ADMIN" v-model="company" :options="items" :total="total" @keyup="emitEvent" @offset="changeOffset" :disabled="mode=='edit'"/>
          <input class="input_tmp_validator" id="company" />
        </div>
        <div class="mt-3">
          <label class="txt-right required">Tên vi phạm an toàn</label>
          <InputText
            v-model="name"
            type="text"
            class="text-box input-text-box"
            placeholder="Nhập"
            maxlength="255"
          />
          <input class="input_tmp_validator" id="name" />
        </div>
        <div class="mt-3">
          <label class="txt-right required">Thứ tự</label>
          <InputText
            v-model="ordinal"
            type="number"
            class="text-box input-text-box"
            placeholder="Nhập"
          />
          <input class="input_tmp_validator" id="ordinal" />
        </div>
        <div class="mt-3">
          <Checkbox v-model="active" :binary="true" />Hiển thị
        </div>
      </div>

      <Toolbar class="fixed-bottom-toolbar">
        <template slot="right">
          <Button
            :label="$constants.TEXT_BUTTON.BACK"
            @click="backToList()"
            class="p-button-warning return-style-button" />
          <Button
            v-if="mode == 'edit'"
            :label="$constants.TEXT_BUTTON.EDIT"
            @click="saveData()"
            class="p-button-success main-style-button" />
          <Button
            v-else
            :label="$constants.TEXT_BUTTON.ADD"
            @click="saveData()"
            class="p-button-success main-style-button" />
        </template>
      </Toolbar>
    </div>
  </form>
</template>

<script>
import DropdownScrollable from '@/components/DropdownScrollable.vue';
import ApiRepository from "@/core/ApiRepository";

export default {
  components:{
    DropdownScrollable
  },
  props: {
    mode: String,
    model: Object,
    company_id: String,
  },
  data() {
    return {
      filters: {},
      name: "",
      ordinal: 1,
      active: true,
      company: {},
      items: [],
      total: 0,
      loading: false,
      offset: 0,
    };
  },
  async mounted() {
    if (this.$store.getters.type == this.$constants.TYPE_USER.SUPPER_ADMIN) {
      await this.getListCompany();
    }
    if (this.model !== undefined && Object.keys(this.model).length > 0) {
      this.company = this.company_id ? {id: this.company_id} : {};
      this.active = this.model.active;
      this.name = this.model.name;
      this.ordinal = this.model.ordinal;
    } else if (this.company_id) {
      this.company = {id: this.company_id};
    }
  },
  methods: {
    backToList() {
      this.$emit("back");
    },
    async emitEvent(keyword) {
      this.$delete(this.filters, 'name');
      if (keyword) {
        this.filters.name = keyword;
      }
      await this.getListCompany();
    },
    async changeOffset(value) {
      this.offset = value;
    },
    async getListCompany() {
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        this.loading = true;
        await ApiRepository.post("/_api/company/options", {filters: this.filters, limit: 20, offset: this.offset}, {headers}).then((res) => {
          if (this.offset > 0) {
            this.items.push(...res.data.data.company);
          } else {
            this.items = res.data.data.company;
          }
          this.total = res.data.data.total;
          this.loading = false;
        }).catch((err) => {
            console.log(err);
            this.loading = false;
        })
      }
    },
    async validateData() {
      this.validationErrors = {};
      if (this.$store.getters.type == this.$constants.TYPE_USER.SUPPER_ADMIN) {
        let company_add = document.getElementById("company");
        if (
          this.$commonFuction.isEmptyObject(this.company) ||
          this.$commonFuction.isEmpty(this.company)
        ) {
          company_add.setCustomValidity("Công ty không được để trống!");
        } else {
          company_add.setCustomValidity("");
        }
      }

      let name_add = document.getElementById("name");
      if (
        this.name == undefined ||
        this.name == null ||
        this.name == ""
      ) {
        name_add.setCustomValidity("Tên vi phạm an toàn không được để trống!");
      } else if (this.name.length > 255) {
        name_add.setCustomValidity("Tên vi phạm an toàn không được quá 255 ký tự!");
      } else {
        name_add.setCustomValidity("");
      }

      let ordinal_add = document.getElementById("ordinal");
      if (
        this.ordinal == undefined ||
        this.ordinal == null ||
        this.ordinal === ""
      ) {
        ordinal_add.setCustomValidity("Thứ tự không được để trống!");
      } else if (this.ordinal <= 0) {
        ordinal_add.setCustomValidity("Thứ tự phải lớn hơn 0!");
      } else {
        ordinal_add.setCustomValidity("");
      }

      var inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity()) {
        inpObj.reportValidity();
        return true;
      }
    },
    async saveData() {
      this.$commonFuction.is_loading(true);
      if (await this.validateData()) {
        this.$commonFuction.is_loading(false);
        return;
      }
      if (Object.entries(this.validationErrors).length !== 0) {
        this.$commonFuction.is_loading(false);
      }

      var params = {
        name: this.name,
        ordinal: this.ordinal,
        active: this.active,
        company: this.company
      };
      this.$emit("save", params);
    }
  },
};
</script>

<style lang="scss">
label {
  font-weight: bold;
}
.p-checkbox {
  margin-right: 1rem !important;
}
</style>
